import React from "react";
import { LoyaltyApi } from "@smartrr/shared/interfaces/loyalty/api";
import { LoyaltyStoreAccess } from "../store";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import { Typography, styled } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";

const IncentiveImageContainer = styled("div")<{ $colorStr: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 90px;
  height: 90px;
  border-radius: ${props => props.theme.modernImageBorderRadius}px;
  background-color: ${props => props.$colorStr};

  & .MuiTypography-root {
    margin: 0;
  }
`;

export const IncentiveColoredImage = ({ incentive }: { incentive: LoyaltyApi.Incentive.Type }) => {
  const { symbol: currencySymbol } = LoyaltyStoreAccess.useCurrency();
  const title =
    incentive.priceRule.type === "fixed_amount"
      ? typedLocalize("loyalty.xUnitsOff", { amount: -incentive.priceRule.value, unitName: currencySymbol })
      : typedLocalize("loyalty.xPercentOff", { amount: -incentive.priceRule.value });

  return (
    <IncentiveImageContainer
      $colorStr={incentive.color}
      className={prefixClassName("loyalty-rewards-incentive-image")}
    >
      <Typography variant="h4">{title}</Typography>
    </IncentiveImageContainer>
  );
};
